import { ExtraStateContext } from "..";
import { Box } from "../../../../../../components/box";
import InformationLayout from "../../../../components/layout/InformationLayout";
import { useProcess } from "../../../../process-context";
import FormButton from "./button";
import FormContent from "./content";

const VehicleTravelCardInformation = () => {
  const { isLongTerm } = useProcess<ExtraStateContext>();

  return (
    <InformationLayout>
      <Box
        title={`Thông tin cấp giấy phép kiểm soát an ninh cho phương tiện VIAGS ${isLongTerm ? "dài hạn" : "ngắn hạn"}`}
        className="full-height"
      >
        <FormContent />
        <FormButton />
      </Box>
    </InformationLayout>
  );
};

export default VehicleTravelCardInformation;
